import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import { useGetSitesQuery } from "../../../features/sites/sitesApiSlice";

export const SiteSelectHookFormField = ({ control, name }) => {
  const { data: sites } = useGetSitesQuery();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl fullWidth sx={{ minWidth: 180 }}>
          <InputLabel id="site-select-label">Standort</InputLabel>
          <Select
            labelId="site-select-label"
            id="site-select"
            value={field.value || ""}
            onChange={field.onChange}
            label="Standort"
          >
            {sites &&
              sites.map((site) => (
                <MenuItem key={site._id} value={site._id}>
                  {site.siteName}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText>Standort auswählen</FormHelperText>
        </FormControl>
      )}
    />
  );
};
